var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { create } from "zustand";
// Zustand store for managing user registration data
export var useUserStore = create(function (set) { return ({
    // Object that stores user registration details
    userObj: {},
    // Function to add a new property to userObj dynamically
    addProp: function (prop, value) {
        return set(function (state) {
            var _a;
            return ({
                userObj: __assign(__assign({}, state.userObj), (_a = {}, _a[prop] = value, _a)),
            });
        });
    },
    // Function to reset userObj to an empty object
    resetUserObj: function () { return set({ userObj: {} }); },
}); });
// Zustand store for managing user login data
export var useUserLoginStore = create(function (set) { return ({
    // Object that stores user login details
    userLoginObj: {},
    // Function to add a new property to userLoginObj dynamically
    addLoginProp: function (prop, value) {
        return set(function (state) {
            var _a;
            return ({
                userLoginObj: __assign(__assign({}, state.userLoginObj), (_a = {}, _a[prop] = value, _a)),
            });
        });
    },
    // Function to reset userLoginObj to an empty object
    resetUserLoginObj: function () { return set({ userLoginObj: {} }); },
}); });
